const PAYMENT_ORDER_MAP_KEY = "tupi:payment-order-map:v1";

function readPaymentOrderMap() {
  try {
    return JSON.parse(window.localStorage.getItem(PAYMENT_ORDER_MAP_KEY) || "{}");
  } catch {
    return {};
  }
}

function writePaymentOrderMap(mapping) {
  try {
    window.localStorage.setItem(PAYMENT_ORDER_MAP_KEY, JSON.stringify(mapping));
  } catch {
    // 支付回跳映射是体验兜底，存储不可用时不影响支付主链路。
  }
}

export function getPaymentTraceNo(paymentResponse) {
  const payment = paymentResponse?.payment || paymentResponse || {};
  return payment.payment_no
    || payment.paymentNo
    || payment.transaction_no
    || payment.transactionNo
    || payment.out_trade_no
    || payment.outTradeNo
    || "";
}

export function rememberPaymentOrder(paymentResponse, orderId) {
  const traceNo = getPaymentTraceNo(paymentResponse);
  if (!traceNo || !orderId) return;
  writePaymentOrderMap({
    ...readPaymentOrderMap(),
    [traceNo]: String(orderId),
  });
}

export function resolvePaymentOrder(traceNo) {
  if (!traceNo) return "";
  return readPaymentOrderMap()[traceNo] || "";
}
